// extracted by mini-css-extract-plugin
export default {"accountAddress":"ShipToAccounts_accountAddress__zm5em","displayAccounts":"ShipToAccounts_displayAccounts__USVTz"};